import { AsyncThunk } from '@algoan/dashboard/store/store';
import { pushNotification, popNotificationStart } from '@algoan/dashboard/store/slice';
import { NotificationContent, NotificationDuration } from '@algoan/dashboard/model';

export const notify =
  (notification: NotificationContent): AsyncThunk =>
  async (dispatch, getState) => {
    const state = getState();

    const notificationInfo = state.appState.notifications[0];

    if (notificationInfo) {
      clearTimeout(notificationInfo.timerId as NodeJS.Timeout);
      dispatch(popNotificationStart());
    }

    const timerId = setTimeout(() => {
      dispatch(popNotificationStart());
    }, NotificationDuration.RENDERED * 1000);

    dispatch(pushNotification({ notification, timerId }));
  };
